import React, { Component } from 'react';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      mouseOver: false
    };
  }

  render() {
    return (
      <div
        className={this.getClassName()}
        onMouseEnter={() => this.updateMouseState(true)}
        onMouseLeave={() => this.updateMouseState(false)}
      >
        <input
          className="App-search-input"
          ref={input => {
            this.textInput = input;
          }}
          onFocus={() => this.updateFocusState(true)}
          onBlur={() => this.updateFocusState(false)}
          onInput={() => this.props.onSearchTextChange(this.textInput.value)}
          onKeyPress={e => this.onKeyPress(e)}
          autoComplete="off"
          title="Search"
          type="text"
        />
      </div>
    );
  }

  getClassName() {
    const hover = this.state.mouseOver || this.state.focused;
    const leName = 'App-search' + (hover ? ' hover-high' : ' hover-low');

    return leName;
  }

  updateFocusState(focused) {
    this.setState({
      focused: focused,
      mouseOver: this.state.mouseOver
    });
  }

  updateMouseState(mouseOver) {
    this.setState({
      focused: this.state.focused,
      mouseOver: mouseOver
    });
  }

  onKeyPress(e) {
    if (e.key === 'Enter') {
      this.props.onSearch(this.textInput.value);

      return false;
    }

    return true;
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/Search.js